import { render, staticRenderFns } from "./orders-pending-container.vue?vue&type=template&id=76ede109&scoped=true&lang=pug"
import script from "./orders-pending-container.js?vue&type=script&lang=js&external"
export * from "./orders-pending-container.js?vue&type=script&lang=js&external"
import style0 from "./orders-pending-container.vue?vue&type=style&index=0&id=76ede109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ede109",
  null
  
)

export default component.exports